import type { AppBadgeCountModeT, Task } from '@portfolio-pm/shared';

interface BadgeNavigator {
  clearAppBadge?(): Promise<void>;
  setAppBadge?(contents?: number): Promise<void>;
}

export function getAppBadgeCount(
  tasks: Task[],
  mode: AppBadgeCountModeT,
  now = Date.now(),
): number {
  const openTasks = tasks.filter(
    (task) => task.completedAt === undefined && task.trashedAt === undefined,
  );
  if (mode === 'open') return openTasks.length;

  const dayStart = new Date(now);
  dayStart.setHours(0, 0, 0, 0);
  const nextDayStart = new Date(dayStart);
  nextDayStart.setDate(nextDayStart.getDate() + 1);

  return openTasks.filter((task) => {
    return [task.dueAt, task.scheduledAt].some(
      (date) => date !== undefined && date >= dayStart.getTime() && date < nextDayStart.getTime(),
    );
  }).length;
}

export async function syncAppBadgeCount(
  count: number,
  navigatorApi: BadgeNavigator | undefined = globalThis.navigator,
): Promise<void> {
  if (!navigatorApi) return;
  if (count > 0 && navigatorApi.setAppBadge) {
    await navigatorApi.setAppBadge(count);
    return;
  }
  if (navigatorApi.clearAppBadge) await navigatorApi.clearAppBadge();
}
